package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_19_Day_2() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Obraxus is missing from the camp, but across the river on top of a cliff are five Obraxuses — it is a trap. Bigglesworth leaps into the river bed and scrambles up the cliff. He shoves two Obraxuses off the cliff into the water. Dirk creates a magical shimmering hand and similarly shoves an Obraxus off the cliff; the force is so strong it launches the Obraxus clear over the river, painfully crashing into the rocky cliff on the opposite side. Tuesday transforms an Obraxus into a frog, flies him high into the air, and drops him. Somehow that Obraxus actually survived the fall, but Korvis finishes him off.")
    }
}
